export class TimeEntryMealBreakStartRequest {
  /**
   * @param {Object} requestData - The request data object.
   * @param {number} requestData.bookingId - The ID of the booking to start a meal break on.
   */
  constructor(requestData) {
    /**
     * The ID of the booking to start a meal break on.
     * @type {number}
     */
    this.bookingId = requestData.bookingId
  }
}
